import { render, staticRenderFns } from "./WhitelabelCheckbox.vue?vue&type=template&id=6ebfa9e2&scoped=true&"
import script from "./WhitelabelCheckbox.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelCheckbox.vue?vue&type=style&index=0&id=6ebfa9e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfa9e2",
  null
  
)

export default component.exports